import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  setProtocols: ['data'],
});

interface IProtocols {
  protocols?: any;
}

const INITIAL_STATE: IProtocols = {
  protocols: [],
};

const setProtocols = (_state = INITIAL_STATE, action: any) => ({
  protocols: [ ...action.data ],
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_PROTOCOLS as any]: setProtocols,
});
